// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselThreeImages {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector('.carousel-three-images');

    if (carousel) {
      const carouselTrack = document.querySelector(
        '.carousel-three-images .wp-block-group'
      );
      const carouselSlides = carouselTrack.querySelector(
        '.carousel-three-images .wp-block-group .wp-block-gallery'
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        '.carousel-three-images .wp-block-group .wp-block-gallery .wp-block-image'
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      // Add arrows
      carousel.insertAdjacentHTML(
        "beforeend",
        `<div class="glide__arrows" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><</button>
                <button class="glide__arrow glide__arrow--right" data-glide-dir=">">></button>
            </div>`
      );

      // Mount carousel
      var threeSlideGlide = new Glide(".carousel-three-images", {
        type: "carousel",
        perView: 3,
        breakpoints: {
          600: { perView: 2 },
        },
        autoplay: 3000,
      }).mount();
    }
  }
}

export default CarouselThreeImages;
